import { Spinner } from '@cian/ui-kit';

import { type FC } from 'react';

import styles from './ElectronicTradingWidgetLoadableFallback.css';

const SPINNER_SIZE = 40;

export const ElectronicTradingWidgetLoadableFallback: FC = () => {
  return (
    <div className={styles['spinner-container']}>
      <Spinner size={SPINNER_SIZE} />
    </div>
  );
};
